import BaseAttribute, { AttributeExport, AttributeExportTypes } from './baseAttribute';
import { Category } from '../character/allValues';

export interface ValueExport extends AttributeExport {
  value: number;
}

export default class ValueAttribute extends BaseAttribute {
  public category: Category = Category.Attribute;

  public value: number = 0;
  public max?: number;

  public toString() {
    return this.value.toString();
  }

  public getClone(): BaseAttribute {
    const clone = new ValueAttribute(this.name);
    clone.value = this.value;

    return clone;
  }

  public export(): ValueExport {
    return {
      value: this.value,
      name: this.name,
      abbreviation: this.abbreviation,
      type: AttributeExportTypes.Attribute,
    };
  }
}
